import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Captcha from '../captcha/Captcha';
import axios from '../../../axios/axios';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class FeedbackForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showError: false,
            showMessage: false,
            isResetCaptcha: false,
        }
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        let value = e.target.value;
        const re = /^[0-9 ()+-]+$/;
        if (name === 'phone' && e.target.value === '' || re.test(e.target.value)) {
            value = e.target.value;
        } else if (name === 'phone') {
            value = e.target.defaultValue;
        }
        this.props.setFeedBackForm(name, value);
        this.setState({...this.state,  showMessage: false, isResetCaptcha: false});
    }

    errorClassField = (error) => {
        return(error  ? '' : 'has-error');
    }

    hasErrorClassForm = (error) => {
        return(error  ? 'has-error' : '');
    }

    errorClassForm = () =>{
        this.setState({...this.state,  showError: true});
    }

    checkState = () => {
        return this.state.showError && !this.props.feedBackForm.formValid &&
                this.props.feedBackForm.isSubmit ? 'error' : '';
    }

    showCaptcha = (isShow) => {
        return isShow  ? 'show' : '';
    }

    setValidClass = (valid) => {
        return valid  ? 'valid' : '';
    }

    handleValidateForm = (event) => {
        event.preventDefault();
        this.props.validateFeedBackForm(); 
        this.props.checkSubmitEvent();
        this.errorClassForm(!this.props.feedBackForm.formValid && !this.props.feedBackForm.isValidated);
    }

    showMessage = () => { 
        return this.state.showMessage ? 'show' : '';
    }

    submitData = (result) => {
        if (result) {
            let data = {
                email: this.props.feedBackForm.email,
                name: this.props.feedBackForm.name,
                phone: this.props.feedBackForm.phone,
                comment: this.props.feedBackForm.message
            }
            axios.post(`/api/welsend/public/partnerFeedBacks`, data)
            .then(response => {
                if (response.status === 200) {
                    this.setState({...this.state, showMessage: true, isResetCaptcha: true}, () => {
                        this.props.clearState();
                    });
                }
            })
            .catch((error =>  {
                  console.log(error.response.data);
            }))
        }
    }

    render () {
        const staticName = translateStaticContent('namePlaceholder', 
                                this.props.defaultStaticContentFeedBack, this.props.activeLangStaticContentFeedBack);
        const staticEmail = translateStaticContent('emailPlaceholder', 
                                this.props.defaultStaticContentFeedBack, this.props.activeLangStaticContentFeedBack);
        const staticPhone = translateStaticContent('phonePlaceholder', 
                                this.props.defaultStaticContentFeedBack, this.props.activeLangStaticContentFeedBack);
        const staticComment = translateStaticContent('commentPlaceholder', 
                                this.props.defaultStaticContentFeedBack, this.props.activeLangStaticContentFeedBack);
        return(
            <div className="form">
                <form id="form" 
                className={`${this.hasErrorClassForm(!this.props.feedBackForm.formValid && 
                              !this.props.feedBackForm.isValidated &&
                              this.props.feedBackForm.isSubmit)}
                ${this.setValidClass(this.props.feedBackForm.formValid)}
                ${this.checkState()}`} >
                     <div className={`form-group ${this.errorClassField(this.props.feedBackForm.nameValid)}`}>
                        <input type="text" className="form-control"
                            placeholder={staticName}
                            minLength={2}
                            maxLength={50}
                            name="name"
                            value={this.props.feedBackForm.name}
                            onChange={this.handleUserInput}/>
                    </div>
                    <div className={`form-group ${this.errorClassField(this.props.feedBackForm.emailValid)}`}>
                        <input type="email" className="form-control"
                            placeholder={staticEmail}
                            name="email"
                            value={this.props.feedBackForm.email}
                            onChange={this.handleUserInput}/>
                    </div>
                    <div className={`form-group ${this.errorClassField(this.props.feedBackForm.phoneValid)}`}>
                        <input type="phone" className="form-control"
                            placeholder={staticPhone}
                            minLength={7}
                            maxLength={50}
                            name="phone"
                            value={this.props.feedBackForm.phone}
                            onChange={this.handleUserInput}/>
                    </div>
                    <div className="form-group">
                        <textarea className="form-control"
                            placeholder={staticComment}
                            minLength={0}
                            maxLength={800}
                            name="message"
                            value={this.props.feedBackForm.message}
                            onChange={this.handleUserInput}
                            rows="4" cols="50">
                        </textarea>
                    </div>
                    <div className="form-group">
                        <input type="checkbox" id="agreement" 
                                name="agreement" 
                                value="agreement"
                                checked={this.props.feedBackForm.agreementValid}
                                onChange={this.handleUserInput}/>
                        <label htmlFor="agreement" className="agreement">
                                {translateStaticContent('checkboxLabel', 
                                    this.props.defaultStaticContentFeedBack, this.props.activeLangStaticContentFeedBack)}
                            <a href="https://drive.google.com/file/d/1wL9EQgb5U5JzLFw6XwCwxul0f5UKJ6cw/view?usp=sharing" 
                                rel="noreferrer" target="_blanck">
                                {translateStaticContent('feedBackLink', 
                                    this.props.defaultStaticContentFeedBack, this.props.activeLangStaticContentFeedBack)}
                            </a>
                        </label>
                    </div>
                    <div className="error-message">
                        {translateStaticContent('feedBackErrorMessage', 
                            this.props.defaultStaticContentFeedBack, this.props.activeLangStaticContentFeedBack)}
                    </div>
                    <button type="submit" className="btn"
                        onClick={this.handleValidateForm}>
                        {translateStaticContent('feedBackBtn', 
                            this.props.defaultStaticContentFeedBack, this.props.activeLangStaticContentFeedBack)}
                    </button>
                    <div className={`captcha-block ${this.showCaptcha(this.props.feedBackForm.formValid &&
                                     this.props.feedBackForm.isValidated)}`}>
                        <Captcha submitData={this.submitData} reset={this.state.isResetCaptcha}/>
                    </div>
                    <div className={`thanks-message ${this.showMessage()}`}>
                        {translateStaticContent('feedBackMessage', 
                            this.props.defaultStaticContentFeedBack, this.props.activeLangStaticContentFeedBack)}
                    </div>
                </form>
            </div>
        )
    }  
}

export default FeedbackForm;

FeedbackForm.propTypes = {
    setFeedBackForm: PropTypes.func.isRequired,
    validateFeedBackForm: PropTypes.func.isRequired,
    feedBackForm: PropTypes.object.isRequired,
    checkSubmitEvent: PropTypes.func.isRequired,
    clearState: PropTypes.func.isRequired,
    defaultStaticContentFeedBack: PropTypes.object,
    activeLangStaticContentFeedBack: PropTypes.object,
}